import { api } from '@/api/client';
import { authApi } from '@/api/login';
import type { UserLanguage } from '@/domain/authentication';

export interface UserManagedBy {
  companyName: string;
  companyId: string;
}

export interface UserProfile {
  username: string;
  email: string;
  registerDate: string;
  phoneNumber?: string;
  managedBy?: UserManagedBy;
}

export interface UserCompanyContact {
  companyId: string;
  companyName: string;
  contactId: string;
  roleId: string;
  roleName?: string;
}

export interface UpdateUserRequest {
  username?: string;
  phoneNumber?: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export type WebAppLanguage = UserLanguage;

export interface SetMyLanguageRequest {
  languageId: WebAppLanguage['id'];
}

export async function fetchUserProfile(userId: string): Promise<UserProfile> {
  return api.get<UserProfile>(`/v1/users/${userId}/profile`);
}

export async function fetchUserCompanyContacts(userId: string): Promise<UserCompanyContact[]> {
  return api.get<UserCompanyContact[]>(`/v1/users/${userId}/contacts`);
}

export async function fetchWebAppLanguages(): Promise<WebAppLanguage[]> {
  return api.get<WebAppLanguage[]>('/v1/config/webAppLanguages');
}

export async function updateUserProfile(
  userId: string,
  data: UpdateUserRequest
): Promise<void> {
  await api.put(`/v1/users/${userId}/profile`, data);
}

export async function changeUserPassword(
  data: ChangePasswordRequest
): Promise<void> {
  await authApi.changePassword(data.currentPassword, data.newPassword);
}

export async function setMyLanguage(
  data: SetMyLanguageRequest
): Promise<void> {
  await api.put('/v1/me/setLanguage', data);
}
